import toasts from "../mixins/toasts";

export default Vue.extend({
    props: {
        filter: {
            type: [Function],
            default: () => {
                return (item) => {
                    return true;
                };
            }
        }
    },
    mixins: [toasts],
    data() {
        return {
            loading: false,
            fetching: false,
            complete: false,
            initialLoad: true,
            __loadingTimeout: null,
            maxWait: 10000,
            options: {
                order: {},
            },
            syncOrder: {},
            endpoint: '.',
            items: [],
            sortParameter: 'order',
            sortColumn: null,
            sortColumnDirection: 'asc',
            page: 1,
            limit: 100,
            total: 0,
            aggregateField: null,
        }
    },
    computed: {
        isTableReady() {
            return !this.loading || this.fetching;
        },
        finishedLoading() {
            return !this.loading && this.complete;
        },
        debouncedSearch() {
            return _.debounce(this.search, 500, { leading: true });
        },
        debouncedFetch() {
            return _.throttle(this.fetch, 250);
        },
        aggregate() {
            if (this.aggregateField) {
                return _.reduce(
                    this.items,
                    (sum, item) => {
                        return sum + item[this.aggregateField];
                    },
                    0
                );
            } else {
                return 0;
            }
        }
    },
    watch: {
        options: {
            handler: 'debouncedSearch',
            deep: true
        }
    },
    methods: {
        resetTable() {
            this.items = [];
            this.loading = true;
            this.initialLoad = true;
        },
        mergeOptions(options) {
            return options;
        },
        getOptions() {
            let options = JSON.parse(JSON.stringify(this.options));

            _.each(options, (parameter, name) => {
                let f = this[_.camelCase(name) + 'ParameterFilter'];
                if (_.isFunction(f) && !_.isEmpty(parameter)) {
                    options[name] = f(parameter);
                }
            });
            return this.filterOptions(options);
        },
        filterOptions(options) {
            return options;
        },
        paramsSerializer(params) {
            return this.$qs.stringify(params);
        },
        initiateLoad(start, finish) {
            let CancelToken = axios.CancelToken;
            let source = CancelToken.source();
            this.loading = true;
            if (_.isFunction(start)) {
                start(source);
            }
            this.__loadingTimeout = _.delay(() => {
                this.finishLoad(finish, source);
            }, this.maxWait);
        },
        finishLoad(func, source) {
            this.loading = false;
            clearTimeout(this.__loadingTimeout);
            if (_.isFunction(func)) {
                func(source);
            }

            this.afterLoad();
        },
        afterLoad() {
            //
        },
        search(force) {
            this.complete = false;
            this.page = 1;
            let options = this.getOptions();
            // Do not try to search if all parameters are the same
            if ((this.loading || _.isEqual(options, this.previousOptions)) && !force) {
                this.loading = false;
                return;
            }
            this.previousOptions = JSON.parse(JSON.stringify(options));
            // Prevents duplicate columns bug
            this.$refs.table.columns = [];
            this.items.splice(0, this.items.length);

            this.$router.replace({
                query: _.pickBy(options)
            });
            _.each(this.syncOrder, (info, field) => {
                let order = this.sortColumnDirection;
                if (_.isBoolean(info)) {
                    let reverse = info;
                    info = {
                        reverse: reverse
                    };
                } else if (!_.isObject(info)) {
                    info = {};
                }

                let fields = info.fields;
                if (!_.isArray(fields)) {
                    fields = [];
                }

                if (info.reverse) {
                    order = order == 'asc' ? 'desc' : 'asc';
                }

                if (field != this.sortColumn && (fields.length == 0 ||
                    fields.length > 0 && _.includes(fields, this.sortColumn)
                )) {
                    options.order[field] = order;
                }
            });
            this.total = 0;
            this.initiateLoad((source) => {
                axios.get(
                    this.endpoint, {
                        cancelToken: source.token,
                        params: _.merge(
                            options,
                            this.filterOptions(
                                this.mergeOptions({
                                    limit: this.limit,
                                })
                            )
                        ),
                        paramsSerializer: params => {
                            return this.paramsSerializer(params);
                        },
                    }
                ).then(response => {
                    let loaded = 0;
                    this.items = [];
                    this.total = _.get(response.data, 'total', 0);
                    _.each(response.data.data, item => {
                        if (this.filter(item)) {
                            this.items.push(item);
                            loaded++;
                        }
                    });
                    this.syncSortableField();
                    this.finishLoad();
                    if (response.data.loaded > loaded) {
                        // If result was filtered try to fetch more automatically
                        this.fetch(1, true);
                    } else {
                        // Lloading has been complete if no new
                        // entries were loaded from the server
                        if (response.data.loaded == 0) {
                            this.complete = true;
                        }

                        if (this.initialLoad) {
                            this.$emit("initialized");
                            this.initialLoad = false;
                        }
                    }
                }).catch(error => {
                    this.finishLoad();
                    this.toast("error", "@unexpected", error);
                });
            }, (source) => {
                source.cancel('timeout');
            });
        },
        fetch(pages = 1, force = false) {
            if (!force &&
                (this.items.length == 0 || this.complete || this.pages < 1 || this.fetching)) {
                return;
            }
            let options = this.getOptions();
            this.total = 0;
            this.initiateLoad((source) => {
                this.fetching = true;
                axios.get(
                    this.endpoint, {
                        cancelToken: source.token,
                        params: _.merge(
                            options,
                            this.filterOptions(
                                this.mergeOptions({
                                    page: this.page + 1,
                                    limit: this.limit,
                                })
                            )
                        ),
                        paramsSerializer: params => {
                            return this.paramsSerializer(params);
                        },
                    }
                ).then(response => {
                    let loaded = 0;
                    this.total = _.get(response.data, 'total', 0);
                    _.each(response.data.data, item => {
                        if (this.filter(item)) {
                            this.items.push(item);
                            loaded++;
                        }
                    });
                    this.syncSortableField();
                    this.page++;
                    pages--;
                    if (pages == 0) {
                        this.finishLoad(() => {
                            this.fetching = false;
                            if (response.data.loaded > loaded) {
                                // If result was filtered try to fetch more automatically
                                this.fetch(1, true);
                            } else {
                                // Lloading has been complete if no new
                                // entries were loaded from the server
                                if (response.data.loaded == 0) {
                                    this.complete = true;
                                }

                                if (this.initialLoad) {
                                    this.$emit("initialized");
                                    this.initialLoad = false;
                                }
                            }
                        });
                    } else {
                        this.fetch(pages);
                    }
                }).catch(error => {
                    this.finishLoad(() => {
                        this.fetching = false;
                    });
                    this.toast("error", "@unexpected", error);
                });
            }, (source) => {
                source.cancel('timeout');
            });
        },
        sort(field, order) {
            let options = JSON.parse(JSON.stringify(this.options));

            this.sortColumnDirection = order == 'asc' ? 'asc' : 'desc';
            if (this.sortColumn != field) {
                this.sortColumn = field;
            }
            options.order = {};
            options.order[field] = order;

            this.options = options;
        },
        syncSortableField() {
            // Sync field if only table ref is provided
            if (this.$refs.table) {
                let field = this.$refs.table.currentSortColumn.field || this.sortColumn;
                this.$nextTick(function () {
                    _.each(this.$refs.table.columns, (column) => {
                        if (column.field == field) {
                            this.$refs.table.currentSortColumn = column;
                            this.$refs.table.isAsc = this.sortColumnDirection == 'asc';
                            return false;
                        }
                    });
                });
            }
        }
    },
    mounted() {
        if (this.endpoint.substr(-1) != '/') {
            this.endpoint += '/';
        }
        _.each(
            _.intersection(_.keys(this.$route.query), _.keys(this.options)),
            name => {
                let parameter = this.$route.query[name];
                let f = this[_.camelCase(name) + 'ParameterFilter'];
                if (_.isFunction(f)) {
                    this.options[name] = f(parameter);
                } else {
                    this.options[name] = parameter;
                }
            });

        let options = {};
        _.merge(options, this.$route.query);
        _.merge(options, this.options);

        if (_.isObject(options.order)) {
            let field = Object.keys(options.order)[0];

            if (field) {
                this.sortColumn = field;
                this.sortColumnDirection = options.order[field];
            }
        }

        if (this.sortColumn) {
            this.sort(this.sortColumn, this.sortColumnDirection);
        } else {
            this.search();
        }
        // Define non-obserable properties
        this.previousOptions = {};
        window.onpopstate = function (event) {
            /**
             * Force reload page when user goes back in history
             * because by Vue Router only changes URL
             */
            location.reload();
        };
    },
})



// WEBPACK FOOTER //
// ./resources/assets/js/components/abstract/RepositorySearch.js